module.exports = __webpack_public_path__ + "c4d93fbddeee91e09c892951b39891a8.jpg";